(function (window, $, undefined) {
    'use strict';
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Files = window.JVZoo.Files || {};

    var UPLOADER_CONTROL_ID_ATTRIBUTE = 'data-jvz-file-upload-control-id';
    var PROGRESS_BAR_ATTRIBUTE = 'data-jvz-file-upload-progress';
    var PROGRESS_BAR_LABEL_ATTRIBUTE = 'data-jvz-file-upload-progress-bar-label';
    var PROGRESS_BAR_FILL_ATTRIBUTE = 'data-jvz-file-upload-progress-bar-fill';
    var FILE_STORE_TYPE_INPUT_ATTRIBUTE = 'data-jvz-file-store-type-id';
    var FILE_URL_INPUT_ATTRIBUTE = 'data-jvz-file-url';
    var FILE_PATH_INPUT_ATTRIBUTE = 'data-jvz-file-path';

    function FileUploader(fileUploadConfiguration) {
        console.debug("FileUploader(fileUploadConfiguration)\nfileUploadConfiguration:", fileUploadConfiguration);
        var _this = this;
        _this.managedFileInputs = [];
        _this.fileUploadConfiguration = fileUploadConfiguration;
        _this.error = undefined;
        _this.pendingAbort = false;

        //requires $.fileupload
        if ($().fileupload === undefined) {
            _this.error = "FileUploader requires jquery.fileupload.js.";
            console.error(_this.error);
            return;
        }

        _this.fileUploadConfiguration.requestHeaders = _this.fileUploadConfiguration.requestHeaders || {};
        _this.fileUploadConfiguration.formAttributes = _this.fileUploadConfiguration.formAttributes || {};
        _this.fileUploadConfiguration.formValues = _this.fileUploadConfiguration.formValues || {};
        _this.fileUploadConfiguration.maxFileSizeInBytes = _this.fileUploadConfiguration.maxFileSizeInBytes || 1024*1000/*1 mb*/;
    }

    FileUploader.prototype.isReady = function() {
        var _this = this;
        if (_this.error === undefined) {
            return true;
        }
        console.log("FileUploader is not ready: ", _this.error());
        return false;
    };

    FileUploader.prototype.addFileInput = function (fileInputElement) {
        var _this = this;
        if (!_this.isReady()) {return;}

        var $fileInput = window.JVZoo.Common.AsjQueryObject(fileInputElement);

        if ($fileInput.attr(UPLOADER_CONTROL_ID_ATTRIBUTE) !== undefined) {
            return;
        }

        $fileInput.attr(UPLOADER_CONTROL_ID_ATTRIBUTE, _this.managedFileInputs.length);
        _this.managedFileInputs.push($fileInput);
        _this.configureFileInputElement(fileInputElement);
    };

    FileUploader.prototype.configureFileInputElement = function(fileInputElement) {
        var _this = this;
        if (!_this.isReady()) {return;}

        var $fileInput = window.JVZoo.Common.AsjQueryObject(fileInputElement);

        var managedFileInputNumber = $(fileInputElement).attr(UPLOADER_CONTROL_ID_ATTRIBUTE);

        var fileInputSelector = '['+UPLOADER_CONTROL_ID_ATTRIBUTE+'='+managedFileInputNumber+']';

        var progressBarSelector
            = $fileInput.closest('[data-jvz-file-upload-progress-bar-selector]').first().attr('data-jvz-file-upload-progress-bar-selector')
            || '['+PROGRESS_BAR_ATTRIBUTE+'='+managedFileInputNumber+']';

        var progressBarLabelSelector = progressBarSelector+' ['+PROGRESS_BAR_LABEL_ATTRIBUTE+']';
        var progressBarFillSelector = progressBarSelector+' ['+PROGRESS_BAR_FILL_ATTRIBUTE+']';
        var fileStoreTypeIdInputSelector = 'input[type=hidden]['+FILE_STORE_TYPE_INPUT_ATTRIBUTE+'='+managedFileInputNumber+']';
        var fileUrlInputSelector = 'input[type=hidden]['+FILE_URL_INPUT_ATTRIBUTE+'='+managedFileInputNumber+']';
        var filePathInputSelector = 'input[type=hidden]['+FILE_PATH_INPUT_ATTRIBUTE+'='+managedFileInputNumber+']';
        var uploadButtonSelector = '.jvz-btn-select-image, .jvz-btn-change-image, .jvz-btn-cancel-change, .jvz-btn-remove-image';

        var showProgress = function(data, message, error) {
            var progress = 0;

            if (data.total === undefined || !(parseFloat(data.total) > 0.0)) {
                /*Cannot report upload progress for fileInputElement because of divide by 0 error, so assume 50%*/
                progress = 50;
            } else {
                progress = parseInt(data.loaded / data.total * 100, 10);
            }

            var $progressBar = $(progressBarSelector);
            if ($progressBar.length < 1) {
                $progressBar = $('<div class="progress">')
                    .attr(PROGRESS_BAR_ATTRIBUTE, managedFileInputNumber);

              $(fileInputSelector).parent().after($progressBar);
            }

            var $progressBarLabel = $(progressBarLabelSelector);
            if ($progressBarLabel.length < 1){
                $progressBar
                    .append(
                        $('<div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">')
                            .attr(PROGRESS_BAR_LABEL_ATTRIBUTE, managedFileInputNumber)
                            .attr(PROGRESS_BAR_FILL_ATTRIBUTE, managedFileInputNumber)
                    )
            }

            $(progressBarLabelSelector).text(message || progress+'%');

            var $progressBarFillElement = $(progressBarFillSelector);
            $progressBarFillElement
              .attr('aria-valuenow', progress)
              .attr('aria-valuemin', 0)
              .attr('aria-valuemax', 100)
              .css('width', progress+'%');

            if (progress < 100 && !error) {
                /*Show In Progress*/
                $progressBarFillElement
                    .addClass('progress-bar-striped')
                    .addClass('progress-bar-animated')
                    .removeClass('bg-success')
                    .addClass('bg-warning')
                    .removeClass('bg-danger');
                return;
            }

            if (error) {
                /*Show Error*/
                $progressBarFillElement
                    .removeClass('progress-bar-striped')
                    .removeClass('progress-bar-animated')
                    .removeClass('bg-success')
                    .removeClass('bg-warning')
                    .addClass('bg-danger');
                return;
            }

            /*Show Completed*/
            $progressBarFillElement
                .removeClass('progress-bar-striped')
                .removeClass('progress-bar-animated')
                .addClass('bg-success')
                .removeClass('bg-warning')
                .removeClass('bg-danger');
        };

        var setUploadButtonsEnabled = function(enabled) {
            var $buttons = $fileInput.closest('.jvz-image-upload-ctl').find(uploadButtonSelector);
            if ($buttons.length < 1) {
                return;
            }
            $buttons
                .toggleClass('disabled', !enabled)
                .attr('aria-disabled', enabled ? 'false' : 'true')
                .css('pointer-events', enabled ? '' : 'none');
        };

        var onFileUploadBeginProcessing = function (e, data) {
            showProgress(data);
            setUploadButtonsEnabled(false);
            window.JVZoo.Controls.PauseFormSubmission.raise($fileInput, $fileInput);
        };

        var setFileUrlInput = function(url) {
            var $fileUrlInput = $(fileUrlInputSelector);
            if ($fileUrlInput.length < 1) {
                $fileUrlInput = $('<input type="hidden">')
                    .attr('name', $(fileInputSelector).attr('name')+'[fileUrl]')
                    .attr(FILE_URL_INPUT_ATTRIBUTE, managedFileInputNumber);
                $(fileInputSelector).after($fileUrlInput);
            }
            $fileUrlInput.val(url);
        };

        var setFileStoreInput = function(fileStoreTypeId) {
            var $fileUrlInput = $(fileStoreTypeIdInputSelector);
            if ($fileUrlInput.length < 1) {
                $fileUrlInput = $('<input type="hidden">')
                    .attr('name', $(fileInputSelector).attr('name')+'[fileStoreTypeId]')
                    .attr(FILE_STORE_TYPE_INPUT_ATTRIBUTE, managedFileInputNumber);
                $(fileInputSelector).after($fileUrlInput);
            }
            $fileUrlInput.val(fileStoreTypeId);
        };

        var setFilePathInput = function(filePath) {
            var $fileUrlInput = $(filePathInputSelector);
            if ($fileUrlInput.length < 1) {
                $fileUrlInput = $('<input type="hidden">')
                    .attr('name', $(fileInputSelector).attr('name')+'[filePath]')
                    .attr(FILE_PATH_INPUT_ATTRIBUTE, managedFileInputNumber);
                $(fileInputSelector).after($fileUrlInput);
            }
            $fileUrlInput.val(filePath);
        };

        var onFileUploadDone = function(e, data) {
            showProgress(data, "Done!");
            setUploadButtonsEnabled(true);

            var $responseXml = $(data.jqXHR.responseXML);

            var $location = $responseXml.find('Location');
            var $bucket = $responseXml.find('Bucket');
            var $key = $responseXml.find('Key');

            if ($location.length < 1 || !$location.text()
                || $bucket.length < 1 || !$bucket.text()
                || $key.length < 1 || !$key.text()
                /*TODO: Validate ETag hash to ensure accurate upload*/
            ) {
                onFileUploadProcessFail(e, data);
                return;
            }

            setFileUrlInput($location.text());
            setFileStoreInput(2/*FileStoreTypes::AWS_TEMPORARY_UPLOAD*/);
            setFilePathInput($key.text());
            window.JVZoo.Controls.AllowFormSubmission.raise($fileInput, $fileInput);
        };

        var onFileUploadProgressAll = function (e, data) {
            showProgress(data);
        };

        var onFileUploadProcessFail = function (e, data) {
            showProgress(data, "Failed!", true);
            setUploadButtonsEnabled(true);
        };
        // This allows onFileUploadProcessFail function to be available on other files
        _this.onFileUploadProcessFail = onFileUploadProcessFail;

        var onBeforeSend = function(xhr) {
            if (_this.fileUploadConfiguration.requestHeaders === undefined) {
                return;
            }
            for(var propertyName in _this.fileUploadConfiguration.requestHeaders) {
                if (headers.hasOwnProperty(propertyName)) {
                    xhr.setRequestHeader(propertyName, _this.fileUploadConfiguration.requestHeaders[propertyName]);
                }
            }
        };

        var removeExifData = function(file, callback) {
            if (!file.type.match(/image.*/)) {
                callback(file);
                return;
            }

            var reader = new FileReader();
            reader.onload = function(e) {
                var img = new Image();
                img.onload = function() {
                    var canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    
                    var ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);
                    
                    canvas.toBlob(function(blob) {
                        var cleanFile = new File([blob], file.name, {
                            type: file.type,
                            lastModified: Date.now()
                        });
                        callback(cleanFile);
                    }, file.type, 0.95);
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        };

        var onAdd = function(e, data) {

            const submitUpload = (file) => {
                data.formData = _this.fileUploadConfiguration.formValues;
                data.formData.key = _this.fileUploadConfiguration.filePath+(file.name.replace(/[^0-9a-zA-Z.]+/g, ''));
                var submitStatus = data.submit();
                _this.currentSubmitStatus = submitStatus;
                if (_this.pendingAbort && submitStatus) {
                    submitStatus.abort();
                    _this.pendingAbort = false;
                }
            }

            var file = data.files[0];
            
            if (file.type.match(/image.*/)) {

                removeExifData(file, (cleanFile) => {
                    data.files[0] = cleanFile;
                    submitUpload(cleanFile);
                });
            } else {
                submitUpload(file);
            }

        }; 

        var fileTypes = /(\.|\/)(gif|jpe?g|png)$/i;

        var fileUploadConfiguration = {
            fileInput:$fileInput,
            replaceFileInput:false,
            acceptFileTypes: fileTypes,
            maxFileSize: 10,//_this.fileUploadConfiguration.maxFileSizeInBytes,
            url: _this.fileUploadConfiguration.url,
            paramName: 'file',
            type: 'POST',
            add: onAdd,
            dataType: 'xml',
            done: onFileUploadDone,
            start:onFileUploadBeginProcessing,
            progressall: onFileUploadProgressAll,
            beforeSend: onBeforeSend,
            fail:onFileUploadProcessFail
        };


        $fileInput.fileupload(fileUploadConfiguration)
            .prop('disabled', !$.support.fileInput)
            .parent().addClass($.support.fileInput ? undefined : 'disabled');


        //if our fileInputElement has, or has a parent that has, the 'FILE_PATH_INPUT_ATTRIBUTE' attribute, we need to restore that into the hidden field now
        var $elementWithDataToRestore = $fileInput.closest('['+FILE_PATH_INPUT_ATTRIBUTE+']');
        setFilePathInput($elementWithDataToRestore.attr(FILE_PATH_INPUT_ATTRIBUTE) || "");

        //if our fileInputElement has, or has a parent that has, the 'data-jvz-file-upload-fqn' attribute, we need to restore that into the hidden field now
        $elementWithDataToRestore = $fileInput.closest('['+FILE_URL_INPUT_ATTRIBUTE+']');
        setFileUrlInput($elementWithDataToRestore.attr(FILE_URL_INPUT_ATTRIBUTE) || "");

        //if our fileInputElement has, or has a parent that has, the 'data-jvz-file-upload-fqn' attribute, we need to restore that into the hidden field now
        $elementWithDataToRestore = $fileInput.closest('['+FILE_STORE_TYPE_INPUT_ATTRIBUTE+']');
        setFileStoreInput($elementWithDataToRestore.attr(FILE_STORE_TYPE_INPUT_ATTRIBUTE) || "");

        window.JVZoo.Controls.FileInputReset.subscribe(
            _this,
            function (args) {
                //something caused our value to be cleared, so let's clean up the hidden fields as well
                if (args.targetElement.is && args.targetElement.is($fileInput)) {
                    setFileStoreInput(0);
                    setFileUrlInput(null);
                    setFilePathInput(null);
                    $(progressBarSelector).remove();
                    setUploadButtonsEnabled(true);
                }
            },
            {}
        );
    };



    window.JVZoo.Files.FileUploader = FileUploader;
})(window, jQuery);
// here